<template>
  <table class="table-fixed w-full">
    <thead class="text-sm">
      <tr>
        <th class="border px-4 py-2">Age</th>
        <th class="border px-4 py-2 text-right">Female</th>
        <th class="border px-4 py-2 text-right">Male</th>
        <th class="border px-4 py-2 text-right">Unknown</th>
        <th class="border px-4 py-2 text-right">Total</th>
      </tr>
    </thead>
    <template v-if="insights.length">
      <TableTbody :metric="metric.name" :insights="normalizedInsights" />
    </template>
  </table>
</template>

<script>
import moment from 'moment';
import { sortBy } from 'lodash-es';
import TableTbody from './metric-gender-age-table-view-tbody.vue';

export default {
  components: {
    TableTbody,
  },
  props: {
    metric: {
      type: Object,
      required: true,
    },
    insights: {
      type: Array,
      required: true,
    },
  },
  computed: {
    byAgeRange() {
      return this.insights.reduce((carry, current) => {
        const [gender, ageRange] = current.label.split('.');

        return {
          ...carry,
          [ageRange]: {
            label: ageRange,
            value: {
              ...(carry?.[ageRange]?.value || { F: 0, M: 0, U: 0 }),
              [gender]: current.value,
            },
          },
        };
      }, {});
    },
    normalizedInsights() {
      return sortBy(Object.keys(this.byAgeRange)).map((ageRange) => this.byAgeRange[ageRange]);
    },
  },
  methods: {
    getTotalRows(obj) {
      return Object.keys(obj).length;
    },
    getHumanReadableDate(date) {
      return moment(date).format('DD/MM/YYYY');
    },
  },
};
</script>
